import React from 'react'
import { useTranslation } from 'react-i18next'

interface NewFlagProps {
  className?: string
}

const NewFlag: React.FC<NewFlagProps> = ({ className = '' }) => {
  const { t } = useTranslation()

  return (
    <div className={`absolute top-2 right-2 z-10 ${className}`}>
      <div className="bg-gradient-to-r from-pink-500 to-red-500 text-white px-2 py-1 text-xs font-bold rounded-tl-lg rounded-br-lg shadow-lg transform rotate-0">
        <span className="block">{t('common.newFlag')}</span>
      </div>
    </div>
  )
}

export default NewFlag